import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';
import { ShareAssetFieldInfo } from '../../fragments/generated/ShareAssetFieldInfo';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type UpdateShareFieldsReelMutationVariables = Types.Exact<{
  shareId: Types.Scalars['ID']['input'];
  fieldsReel?: Types.InputMaybe<Array<Types.CollectionFieldInput>>;
}>;


export type UpdateShareFieldsReelMutation = { __typename?: 'Mutation', updateShare?: { __typename?: 'UpdateSharePayload', share?: { __typename?: 'AdHocAssetsShare', id: string, fieldsReel?: { __typename?: 'ShareFieldConnection', totalCount: number, nodes: Array<{ __typename?: 'ShareField', isFrozen?: boolean | null, isVisible?: boolean | null, width?: number | null, fieldDefinition?: { __typename?: 'ProjectFieldDefinition', id: string, name: string } | null } | null> } | null } | { __typename?: 'CollectionShare', id: string, fieldsReel?: { __typename?: 'ShareFieldConnection', totalCount: number, nodes: Array<{ __typename?: 'ShareField', isFrozen?: boolean | null, isVisible?: boolean | null, width?: number | null, fieldDefinition?: { __typename?: 'ProjectFieldDefinition', id: string, name: string } | null } | null> } | null } | null } | null };


export const UpdateShareFieldsReel = /*#__PURE__*/ gql`
    mutation UpdateShareFieldsReel($shareId: ID!, $fieldsReel: [CollectionFieldInput!]) {
  updateShare(input: {shareId: $shareId, fieldsReel: $fieldsReel}) {
    share {
      id
      ... on AssetAggregate {
        fieldsReel(page: {first: 100}) {
          nodes {
            ...ShareAssetFieldInfo
          }
          totalCount
        }
      }
    }
  }
}
    ${ShareAssetFieldInfo}` as unknown as DocumentNode<UpdateShareFieldsReelMutation, UpdateShareFieldsReelMutationVariables>;

          

          export const useUpdateShareFieldsReelMutation = (options?:MutationHookOptions<UpdateShareFieldsReelMutation, UpdateShareFieldsReelMutationVariables>) => useMutation(UpdateShareFieldsReel, options);
          

          export type UpdateShareFieldsReelMutationOptions = MutationHookOptions<UpdateShareFieldsReelMutation, UpdateShareFieldsReelMutationVariables>;

          

          export type UpdateShareFieldsReelMutationResult = ReturnType<typeof useUpdateShareFieldsReelMutation>[1];

          
